// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"style_pageWrapper__Qu0hd","container":"style_container__DNCFv","alertOldKeys":"style_alertOldKeys__YpiJe","icon":"style_icon__Gcfjt"};